import * as React from 'react';
import ReactSelect from 'react-select';
import {UserRole} from '~/apps/shared/consts';


export default class SalesListFilter extends React.Component<any, any> {
  filterRef;

  constructor(props) {
    super(props);
    this.filterRef = React.createRef();
  }

  onFilter = (e) => {
    e.preventDefault();

    this.props.onFilter(this.filterRef.current.value);
  };

  onLocationChange = (option) => {
    this.props.onLocationChange(option.value);
  };

  onDepartmentChange = (option) => {
    this.props.onDepartmentChange(option.value);
  }

  getDepartmentOptions = () => {
    const {filter, departmentOptions} = this.props;

    if (filter.departmentId) {
      return [{value: null, label: 'Remove Filter'}].concat(departmentOptions);
    }

    return departmentOptions;
  }

  handleStatusChange = (option) => {
    const {onStatusChange} = this.props;

    if (onStatusChange) {
      onStatusChange(option.value);
    }
  }

  render = () => {
    const {
      locationHelper,
      filter,
      onLocationChange,
      userRole,
      hasDepartmentFeature,
      departmentOptions,
      statusHelper,
      onStatusChange
    } = this.props;
    const isLocationSelect = userRole !== UserRole.WAREHOUSE_MANAGER;

    let options;

    if (filter.locationId) {
      options = [{value: null, label: 'Remove Filter'}].concat(locationHelper.options);
    } else {
      options = locationHelper.options;
    }

    let statusesOptions
    if (filter.status) {
      statusesOptions = [{value: null, label: 'Remove Filter'}].concat(statusHelper.options);
    } else {
      statusesOptions = statusHelper.options;
    }

    return (
      <div className="filter__cont" style={{zIndex: 2}}>
        <div className="filter__title"/>
        <div className="filter__controls">
          {/*
          <ReactSelect
            className="filter--drop"
            placeholder="All Carriers"
            classNamePrefix="filter--drop"
          />
          */}
          {!!onStatusChange && <ReactSelect
            name="status"
            label="Status"
            className="filter--drop"
            placeholder="All Statuses"
            classNamePrefix="filter--drop"
            value={statusHelper.getSelectValue(filter.status)}
            options={statusesOptions}
            onChange={this.handleStatusChange}
            onInputChange={statusHelper.search}
            isLoading={!!statusHelper.isLoading}
          />}
          {isLocationSelect && onLocationChange && (
            <ReactSelect
              name="locationId"
              label="Location"
              className="filter--drop"
              placeholder="All Locations"
              classNamePrefix="filter--drop"
              value={locationHelper.getSelectValue(filter.locationId)}
              options={options}
              onChange={this.onLocationChange}
              onInputChange={locationHelper.search}
              isLoading={!!locationHelper.isLoading}
            />
          )}

          {hasDepartmentFeature &&
            <ReactSelect
              name="departmentId"
              label="Department"
              className="filter--drop"
              placeholder="All Departments"
              classNamePrefix="filter--drop"
              value={filter.departmentId ? departmentOptions.find(dep => dep.value === filter.departmentId) : null}
              options={this.getDepartmentOptions()}
              onChange={this.onDepartmentChange}
            />
          }

          <form onSubmit={this.onFilter}>
            <div className="input--search input--ti">
              <a onClick={this.onFilter} href="javascript:void(null)" className="input__icon input--search__btn">
                <span className="i i-search"/>
              </a>
              <input
                type="text"
                placeholder="Search"
                ref={this.filterRef}
                defaultValue={filter && filter.q}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}
